import { orderXClient } from '@/service/client'
import {
  ListSessionsResponse,
  LogoutResponse,
  RevokeAllOtherSessionsResponse,
  RevokeSessionRequest,
  RevokeSessionResponse,
} from '@/types/generated/common/auth'
import {
  MintMessagingLinkNonceRequest,
  MintMessagingLinkNonceResponse,
  ServerMessage,
} from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

export async function listSessions() {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', { listSessions: {} })
    const listSessionsResponse = data.listSessionsResponse as ListSessionsResponse
    if (!listSessionsResponse?.success) {
      return Promise.reject({
        status: 400,
        message: listSessionsResponse?.errorMessage || 'Failed to list sessions',
      })
    }
    return listSessionsResponse
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}

export async function revokeSession(payload: RevokeSessionRequest) {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', { revokeSession: payload })
    const revokeSessionResponse = data.revokeSessionResponse as RevokeSessionResponse
    if (!revokeSessionResponse?.success) {
      return Promise.reject({
        status: 400,
        message: revokeSessionResponse?.errorMessage || 'Failed to revoke session',
      })
    }
    return revokeSessionResponse
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}

export async function revokeAllOtherSessions() {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', {
      revokeAllOtherSessions: {},
    })
    const revokeAllOtherSessionsResponse =
      data.revokeAllOtherSessionsResponse as RevokeAllOtherSessionsResponse
    if (!revokeAllOtherSessionsResponse?.success) {
      return Promise.reject({
        status: 400,
        message: revokeAllOtherSessionsResponse?.errorMessage || 'Failed to revoke other sessions',
      })
    }
    return revokeAllOtherSessionsResponse
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}

export async function mintMessagingLinkNonce(payload: MintMessagingLinkNonceRequest) {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', {
      mintMessagingLinkNonce: payload,
    })
    const mintMessagingLinkNonceResponse =
      data.mintMessagingLinkNonceResponse as MintMessagingLinkNonceResponse
    if (!mintMessagingLinkNonceResponse?.success) {
      return Promise.reject({
        status: 400,
        message: mintMessagingLinkNonceResponse?.errorMessage || 'Failed to generate Telegram link',
      })
    }
    return mintMessagingLinkNonceResponse
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}

export async function logout() {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', { logout: {} })
    const logoutResponse = data.logoutResponse as LogoutResponse
    if (!logoutResponse?.success) {
      return Promise.reject({
        status: 400,
        message: logoutResponse?.errorMessage || 'Failed to log out',
      })
    }
    return logoutResponse
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}
